import { Slide } from "packages/lesson/dist/@types";

import { task as task04 } from "../../../../../task/course-05/lesson-17/task-04";

const task: Slide = {
  title: "If we increase the mass of wall the sound reduction index is:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task04.id,
        },
      },
    },
  },
};

export default task;
